import React, { useState } from 'react';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { baseurladdress } from "../baseurl";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";

function Editjobposting(props) {
    const { ddcrecruitmentposting_id } = useParams();
    const accesstoken = localStorage.getItem("token");
    const navigate = useNavigate();
    const Swal = require('sweetalert2')

    const [ddcrecruitmentposting_jobtitle, setddcrecruitmentposting_jobtitle] = useState("");
    const [ddcrecruitmentposting_location, setddcrecruitmentposting_location] = useState("");
    const [ddcrecruitmentposting_address, setddcrecruitmentposting_address] = useState("");
    const [ddcrecruitmentposting_jobstatus, setddcrecruitmentposting_jobstatus] = useState("");
    const [ddcrecruitmentposting_jobdescription, setddcrecruitmentposting_jobdescription] = useState("");
    const [branch_name, setbranch_name] = useState([]);
    useEffect(() => {

        axios
            .get(baseurladdress + `editjobposting/` + ddcrecruitmentposting_id, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                const data = res.data.response;

                setddcrecruitmentposting_jobtitle(data[0].ddcrecruitmentposting_jobtitle);
                setddcrecruitmentposting_location(data[0].ddcrecruitmentposting_location);
                setddcrecruitmentposting_address(data[0].ddcrecruitmentposting_address);
                setddcrecruitmentposting_jobstatus(data[0].ddcrecruitmentposting_jobstatus);
                setddcrecruitmentposting_jobdescription(data[0].ddcrecruitmentposting_jobdescription);


                getbranch();


            });
    }, [ddcrecruitmentposting_id]);

    //    single delete
    const Delete = () => {
        if (
            window.confirm(
                "Sure you want to delete this data? This cannot be undo later."
            )
        ) {
            fetch(baseurladdress + `deletejobpost/${ddcrecruitmentposting_id}`, {
                method: "POST",

                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }).then((response) => {
                if (response.status === 200) {


                    navigate("/joblist");
                }
            });
        }
    };

    // get branch name
    const getbranch = () => {
        axios.get(baseurladdress + `getbranchname`, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                const user = data.map((item, index) => {
                    return (
                        <option value={item.branch_name}> {item.branch_name} </option>
                    )
                }
                );
                setbranch_name(user);
            }).catch(error => {
                alert(error);
            })
    }

    // branch address
    const changeAddress = (ddcrecruitmentposting_address) => {
        // alert(ddcrecruitmentposting_address);
        axios.get(baseurladdress + `getaddress/` + ddcrecruitmentposting_address, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                // alert(data[0].branch_place);
                // console.log(data);
                // const user = data.map((item, index) => {
                //     return (
                //         <option value={item.branch_place}> {item.branch_place} </option>
                //     )
                // }
                // );
                setddcrecruitmentposting_address(data[0].branch_place);
            }).catch(error => {
                alert(error);
            })
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        var data = {
            ddcrecruitmentposting_jobtitle: ddcrecruitmentposting_jobtitle,
            ddcrecruitmentposting_location: ddcrecruitmentposting_location,
            ddcrecruitmentposting_address: ddcrecruitmentposting_address,
            ddcrecruitmentposting_jobstatus: ddcrecruitmentposting_jobstatus,
            ddcrecruitmentposting_jobdescription: ddcrecruitmentposting_jobdescription,
            ddcrecruitmentposting_id: ddcrecruitmentposting_id,
        };
        fetch(baseurladdress + `updatejobposting/` + ddcrecruitmentposting_id, {
            method: "POST",
            headers: {
                Accept: "application/form-data",
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
            body: JSON.stringify(data),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result["status"] === "updated") {
                    // alert(result["message"]);

                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1200,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'success',
                        title: 'Edited Successfully'
                    })

                    navigate("/joblist");

                } else {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 500,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'error',
                        title: 'Something went wrong'
                    })
                }
            });
    };
    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div class="content-wrap" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                <div className="container-fluid">
                    <NavLink activeClassName="active-link" to={"/joblist"}>
                        <div style={{ display: "flex" }}>
                            <a class="float">
                                <i class="fa fa-arrow-left my-float" style={{ "marginTop": "21px" }}></i>
                            </a>
                        </div>

                        <div style={{ display: "flex" }}>
                            <a class="deletefloat" onClick={Delete} >
                                <i class="fa fa-trash mydelete-float" ></i>
                            </a>
                        </div>
                    </NavLink>
                    <form onSubmit={handleSubmit}>
                        <div className='row'>
                            <div class="col-xl-12 col-xxl-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h4 class="card-title">Edit Job Details</h4>
                                    </div>

                                    <div class="card-body">
                                        <div class="basic-form">

                                            <div class="form-row">

                                                <div class="col-sm-12 mt-sm-0">
                                                    <h6>Job Title</h6>

                                                    <input type="text"
                                                        class="form-control"
                                                        value={ddcrecruitmentposting_jobtitle}
                                                        onChange={(e) => setddcrecruitmentposting_jobtitle(e.target.value)}


                                                    />
                                                </div>
                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Job Location</h6>


                                                    <select
                                                        className="form-control select"
                                                        name="employee"
                                                        id="employee"
                                                        value={ddcrecruitmentposting_location}
                                                        // onChange={(e) => setddcrecruitmentposting_location(e.target.value)}
                                                        onChange={(e) => { changeAddress(e.target.value); setddcrecruitmentposting_location(e.target.value) }}



                                                    >

                                                        <option value="" disabled selected>
                                                            Select
                                                        </option>
                                                        {branch_name}
                                                    </select>
                                                </div>


                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Job Address</h6>
                                                    <input type="text" class="form-control"
                                                        value={ddcrecruitmentposting_address}
                                                        onChange={(e) => setddcrecruitmentposting_address(e.target.value)}

                                                    />
                                                </div>

                                                <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Status</h6>
                                                    <select
                                                        className="form-control select"
                                                        name="status"
                                                        value={ddcrecruitmentposting_jobstatus}
                                                        onChange={(e) => setddcrecruitmentposting_jobstatus(e.target.value)}

                                                    >

                                                        <option value="" disabled selected>
                                                            Select
                                                        </option>
                                                        <option value="0">
                                                            Pending
                                                        </option>
                                                        <option value="1">
                                                            Publish
                                                        </option>
                                                        <option value="2">
                                                            Onhold
                                                        </option>
                                                    </select>

                                                </div>

                                                <div class="col-sm-12 mt-2 mt-sm-0">
                                                    <h6>Job Description</h6>
                                                    <textarea class="form-control " style={{ height: "10em" }}
                                                        value={ddcrecruitmentposting_jobdescription}
                                                        onChange={(e) => setddcrecruitmentposting_jobdescription(e.target.value)}

                                                    />
                                                </div>






                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-12 offset-6">
                                        <button type="submit" class="btn btn-primary mb-2" >UPDATE</button>
                                    </div>

                                </div>
                            </div>





                        </div>
                    </form>
                </div>

            </div>
        </div>
    );
}

export default Editjobposting;